import { OrderStatus } from '../../../types/OrderStatus'
import { OrderDto } from '../../../types/swaggerTypes'
import { shippedStatuses } from '../../MaOrderDetail/MaOrderDetail.models'

/**
 * CLOS-14614: re-ordering is only offered once the order has shipped, so the
 * order confirmation page cannot place the same order a second time.
 */
export const isOrderAgainDisabled = (order: OrderDto | undefined): boolean =>
  !order || !shippedStatuses.includes(order.orderStatus as OrderStatus)
